//---- components ---------
//---- mixins -------------
//---- services -----------
//---- other --------------
import customUrls from './CustomUrls.js'
import defaultUrls from './DefaultUrls.js'
//---- 3rd-parties --------

export default { 
    ...defaultUrls, // start with default urls
    ...customUrls   // overwrite defaults with customs        
}  